"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Section = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Headline = _interopRequireDefault(require("../Headline"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _index = require("../../provider/ThemeProvider/index");

var _classnames = _interopRequireDefault(require("classnames"));

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

/**
 * A generic section component providing basic section alignment and styling
 *
 * @param	{string}			backgroundClass	An additional background class (E.g. Image styles)
 * @param	{string}			backgroundColor	A css conform hex/rgb/rgba color code
 * @param	{string}			className       Additional class selector
 * @param {content}			headline				The sections headline
 * @param	{content}			subheader				The sections subheader
 * @param	{boolean}			noPadding				Wether or not to render with padding
 * @param	{boolean}			noMargin				Wether or not to render with margin
 * @param	{boolean}			center					Wether or not to center the content
 * @param	{Children}    children				The sections content
 * @param	{boolean} 	  row				      Wether or not to provide a row wrapper (// TODO: Refactor)
 * @param {string}      dividerStyle    The display style of the sections divider
 **/
var Section = function Section(_ref) {
  var _cn, _cn2;

  var children = _ref.children,
      _ref$backgroundClass = _ref.backgroundClass,
      backgroundClass = _ref$backgroundClass === void 0 ? false : _ref$backgroundClass,
      className = _ref.className,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? 'default' : _ref$backgroundColor,
      _ref$headline = _ref.headline,
      headline = _ref$headline === void 0 ? false : _ref$headline,
      _ref$subheader = _ref.subheader,
      subheader = _ref$subheader === void 0 ? false : _ref$subheader,
      _ref$noPadding = _ref.noPadding,
      noPadding = _ref$noPadding === void 0 ? false : _ref$noPadding,
      _ref$noPaddingBottom = _ref.noPaddingBottom,
      noPaddingBottom = _ref$noPaddingBottom === void 0 ? false : _ref$noPaddingBottom,
      _ref$noPaddingTop = _ref.noPaddingTop,
      noPaddingTop = _ref$noPaddingTop === void 0 ? false : _ref$noPaddingTop,
      _ref$noMargin = _ref.noMargin,
      noMargin = _ref$noMargin === void 0 ? false : _ref$noMargin,
      _ref$center = _ref.center,
      center = _ref$center === void 0 ? false : _ref$center,
      _ref$contentPadding = _ref.contentPadding,
      contentPadding = _ref$contentPadding === void 0 ? false : _ref$contentPadding,
      _ref$row = _ref.row,
      row = _ref$row === void 0 ? true : _ref$row,
      anchor = _ref.anchor,
      _ref$globalThemeVaria = _ref.globalThemeVariant,
      globalThemeVariant = _ref$globalThemeVaria === void 0 ? 'pc' : _ref$globalThemeVaria,
      _ref$dividerStyle = _ref.dividerStyle,
      dividerStyle = _ref$dividerStyle === void 0 ? 'none' : _ref$dividerStyle,
      _ref$smallPaddingBott = _ref.smallPaddingBottom,
      smallPaddingBottom = _ref$smallPaddingBott === void 0 ? false : _ref$smallPaddingBott,
      _ref$globalThemeSubVa = _ref.globalThemeSubVariant,
      globalThemeSubVariant = _ref$globalThemeSubVa === void 0 ? '' : _ref$globalThemeSubVa,
      _ref$target = _ref.target,
      target = _ref$target === void 0 ? '' : _ref$target;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", {
    className: (0, _classnames.default)((_cn = {}, (0, _defineProperty2.default)(_cn, _styleModule.default.section, true), (0, _defineProperty2.default)(_cn, _styleModule.default.noPadding, noPadding), (0, _defineProperty2.default)(_cn, _styleModule.default.noPaddingTop, noPaddingTop), (0, _defineProperty2.default)(_cn, _styleModule.default.noPaddingBottom, noPaddingBottom), (0, _defineProperty2.default)(_cn, _styleModule.default.smallPaddingBottom, smallPaddingBottom), (0, _defineProperty2.default)(_cn, _styleModule.default.news, globalThemeSubVariant === 'news'), (0, _defineProperty2.default)(_cn, className, className), _cn), _styleModule.default[globalThemeVariant]),
    style: {
      marginTop: noMargin && '0'
    },
    children: [anchor && /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
      className: _styleModule.default.pseudoAnchor,
      id: anchor,
      children: ' '
    }), globalThemeVariant === 'bc' && dividerStyle !== 'none' && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classnames.default)(_styleModule.default.dividerTop, _styleModule.default[dividerStyle])
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classnames.default)(noPadding === true ? '' : _styleModule.default.background, [_styleModule.default[backgroundColor]], (_cn2 = {}, (0, _defineProperty2.default)(_cn2, backgroundClass, backgroundClass), (0, _defineProperty2.default)(_cn2, _styleModule.default.hasHeader, headline || subheader), _cn2)),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
        children: [(headline || subheader) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
          className: _styleModule.default.header,
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
            item: true,
            children: [headline && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Headline.default, {
              size: 2,
              noMargin: true,
              center: globalThemeVariant === 'pc',
              color: backgroundColor === 'dark' ? 'white' : null,
              className: target === 'truck' && "".concat(_styleModule.default[target], " ").concat(_styleModule.default.h2),
              children: headline
            }), subheader && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Headline.default, {
              size: 3,
              noMargin: true,
              center: true,
              color: backgroundColor === 'dark' ? 'white' : null,
              className: target === 'truck' && "".concat(_styleModule.default[target], " ").concat(_styleModule.default.h3),
              children: subheader
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: contentPadding ? _styleModule.default.contentPadding : _styleModule.default.content,
          style: {
            textAlign: center ? 'center' : 'left',
            padding: '0'
          },
          children: row ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
            className: "justify-content-md-center",
            children: children
          }) : children
        })]
      })
    }), globalThemeVariant === 'bc' && dividerStyle !== 'none' && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classnames.default)(_styleModule.default.dividerBottom, _styleModule.default[dividerStyle])
    })]
  });
};

exports.Section = Section;

var _default = (0, _index.withThemeVariant)(Section);

exports.default = _default;